import {
  init,
  browserTracingIntegration,
  thirdPartyErrorFilterIntegration,
} from '@sentry/gatsby'

import { getAppEnvironment } from './src/utils/runtimeEnvironment'

init({
  dsn: 'https://82e0741a868049fd5560c89250ce7bec@o4506859562205184.ingest.us.sentry.io/4506859619155968',
  denyUrls: [
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    /graph\.facebook\.com/i,
    /connect\.facebook\.net/i,
    /googletagmanager\.com/i,
    /google-analytics\.com/i,
    /amplitude\.com/i,
  ],
  ignoreErrors: [
    'Non-Error promise rejection captured',
    /Error: We couldn't load "\/page-data\//i,
    /Cannot read properties of null \(reading 'style'\)/i,
    /Importing a module script failed/i,
    /Cannot read properties of undefined \(reading 'componentChunkName'\)/i,
    /undefined is not an object \(evaluating 'e\.componentChunkName'\)/i,
    /Failed to fetch dynamically imported module: https:\/\/sphere-assets\.decathlon\.net\//i,
  ],
  integrations: [
    browserTracingIntegration({
      enableLongTask: false,
      enableLongAnimationFrame: false,
      enableInp: false,
    }),
    thirdPartyErrorFilterIntegration({
      filterKeys: ['dkd-sentry-faststore-own-code'],
      behaviour: 'drop-error-if-contains-third-party-frames',
    }),
  ],
  beforeSend(event, hint) {
    const error = hint?.originalException
    if (error && error.__sentry_captured) return null
    return event
  },
  environment: getAppEnvironment() ?? process.env.NODE_ENV,
  debug: false,
  enabled: true,
  sampleRate: 0.2, // Captura 20% dos eventos de erro
  tracesSampleRate: 0.01, // Captura 1% das transações de rastreamento (relacionadas ao desempenho)
})
